import React from "react";
import {
  featureSettings,
  repositoryIntegrations,
  policySettings
} from "../../routes/AdminRoutes";
import { Route } from "react-router-dom";
import FeatureSettings from "../../views/Settings/Feature/FeatureSettings";
import IntegrationSettings from "../../views/Settings/RepositoryIntegration/IntegrationSettings";
import PolicySettings from "../../views/Settings/PolicySettings/PolicySettings";
import usePermissions from "../../redux/selectors/usePermissions";

export default function AdminSettings() {
  const { showFeatureSettings, allowRepositoryIntegration } = usePermissions(); //Workaround while we only have feature settings for customers with validate 2.0 permissions
  return (
    <>
      {showFeatureSettings && (
        <Route path={featureSettings} component={FeatureSettings} />
      )}
      {allowRepositoryIntegration && (
        <Route path={repositoryIntegrations} component={IntegrationSettings} />
      )}
      {<Route path={policySettings} component={PolicySettings} />}
    </>
  );
}

AdminSettings.propTypes = {};
